import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import CauseBeneficiaryCard from "@/components/campaignBuilder/review/CauseBeneficiaryCard/CauseBeneficiaryCard";
import CheckoutCard from "@/components/campaignBuilder/review/CheckoutCard/CheckoutCard";
import FundingWalletCard from "@/components/campaignBuilder/review/FundingWalletCard/FundingWalletCard";
import RecipientExperienceCard from "@/components/campaignBuilder/review/RecipientExperienceCard/RecipientExperienceCard";
import SettingsReviewCard from "@/components/campaignBuilder/review/SettingsReviewCard/SettingsReviewCard";
import { CAMPAIGN_NAME_TEXT } from "@/constants/campaignBuilder";
import { useCampaignBuilder } from "@/context/CampaignBuilderContext";

export default function ReviewStep() {
  const { campaignName, openCampaignRename } = useCampaignBuilder();

  return (
    <div className="max-w-300 mx-auto px-5 py-8 w-full">
      <h1 className="mb-1">Review and launch.</h1>

      {campaignName && (
        <div className="flex items-center gap-1 min-w-0 mt-2">
          <span
            className="font-lato text-[15px] text-graphite truncate min-w-0"
            title={campaignName}
          >
            {campaignName}
          </span>
          <Tooltip title={CAMPAIGN_NAME_TEXT.renameAction}>
            <IconButton
              size="small"
              className="shrink-0"
              aria-label={CAMPAIGN_NAME_TEXT.renameAction}
              onClick={openCampaignRename}
            >
              <EditOutlinedIcon sx={{ fontSize: 16, color: "var(--color-graphite)" }} />
            </IconButton>
          </Tooltip>
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1.55fr)_minmax(360px,1fr)] gap-8 items-start mt-6">
        {/* Left column */}
        <div className="flex flex-col gap-5 min-w-0">
          <RecipientExperienceCard />
          <CauseBeneficiaryCard />
          <SettingsReviewCard />
        </div>

        {/* Right column. `top-8` matches this page's own `py-8`, so the pinned card lines up with
            the top of the content rather than sitting below it — the offset is measured from the
            scrollport, which starts under the nav, not from the top of the window. */}
        <div className="lg:sticky lg:top-8 self-start flex flex-col gap-5">
          <FundingWalletCard />
          <CheckoutCard />
        </div>
      </div>
    </div>
  );
}
